import { useEffect, useState } from 'react';
const useServices = () => {
    const [services, setServices] = useState([]);
    const baseUrl = window.location.origin;
    useEffect(() => {
        fetch(`${baseUrl}/fakeData/services.json`)
            .then(response => response.json())
            .then(data => setServices(data))
    }, [])

    return [services]

}
export default useServices
